import { Box, Skeleton } from '@mui/material';

export function OverlayContentSkeleton() {
  return (
    <>
      <h2>
        <Skeleton variant="text" width={300} />
      </h2>
      <div className="line" />
      <Box sx={{ mt: 2 }}>
        <Skeleton variant="rectangular" height={80} sx={{ mb: 2 }} />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" width="70%" />
        <Skeleton variant="rectangular" height={200} sx={{ mt: 2 }} />
      </Box>
    </>
  );
}

const KpiTileSkeleton = () => (
  <div className="kpi-container">
    <h2>
      <Skeleton variant="text" width={110} height={40} />
    </h2>
    <span>
      <Skeleton variant="text" width={80} />
    </span>
  </div>
);

export function OverlayFooterKpisSkeleton() {
  return (
    <>
      <KpiTileSkeleton />
      <KpiTileSkeleton />
      <KpiTileSkeleton />
      <KpiTileSkeleton />
    </>
  );
}
